import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import {
  IAsideRightOptions,
  ITag,
  IPill,
  Status,
  LayoutService,
  ToastService,
} from 'codex-lib';
import { EnvelopeService } from '../../services/envelope.service';
import { Envelope } from '../../model/envelope';
import { TranslateService } from '@ngx-translate/core';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { SignatureStatus } from 'src/app/enum/signature-status';
import { LanguageBase } from '../../model/language';
import { EMPTY, Subscription, combineLatest } from 'rxjs';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileEnvelopeService } from '../../services/file-envelope.service';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AuthService } from 'src/app/services/auth.service';
import { Signature } from '../../model/signature';
import { SignatureType } from 'src/app/enum/signature-type';
import { EnvelopeReminderService } from '../../services/envelope-reminder';
import { RoutePages } from 'src/app/enum/route-pages';
import { environment } from 'src/environments/environment';
import { DatetimeFormatLanguageEnum } from 'src/app/enum/datetime-format-language.enum';
import { UserTypes } from 'src/app/enum/user-types';
import { StringUtil } from 'src/app/util/string-util';
import { AuthUtilService } from 'src/app/services/auth-util.service';

@Component({
  selector: 'app-sent-detail-sidebar',
  templateUrl: './sent-detail-sidebar.component.html',
  styleUrls: ['./sent-detail-sidebar.component.scss'],
})
export class SentDetailSidebarComponent
  implements OnChanges, AfterViewInit, OnDestroy
{
  @Input() envelopeId: number;
  @Input() envelopeStatus: SentEnvelopeStatus;
  @Output() discardEnvelope = new EventEmitter();
  @Output() updateCardEnvelope = new EventEmitter();

  activeModal: NgbActiveModal;
  envelope: Envelope;
  signatureStatus = SignatureStatus;
  languageBase: LanguageBase;
  totalApprovedAuthorizations = 0;
  statusEnvelope = Status;
  canViewActionsButton = false;
  canShowEditButton = false;
  isCollapsed = false;
  showSignatureInPerson: boolean;
  elementSelected: Envelope;
  datetimeFormatLanguageEnum = DatetimeFormatLanguageEnum;
  canSendWhatsApp: boolean = false;
  isCreatedEnvelope: boolean = false;
  userTypeLogged: UserTypes;
  userId;
  isAdmin;
  totalSignatoriesRejectedReason: any[] = [];
  reprovedDate ;

  rightOptions: IAsideRightOptions = {
    overlapContent: false,
    title: 'details',
    icon: {
      iconName: 'info-circle',
      prefix: 'fad',
    },
  };

  pill: IPill = {
    icon: {
      iconName: 'clock',
      prefix: 'fas',
    },
    description: this.getStatusDescription(),
    type: this.getStatusType(),
  };

  tagStatus: ITag = {
    description: this.getStatusDescription(),
    tooltip: this.translate.instant('envelopeStatus'),
    tooltipPlacement: 'top',
    type: this.getStatusType(),
  };

  sentEnvelopeStatus = SentEnvelopeStatus;
  signatureType = SignatureType;
  documentoURL: string;
  authorizers: Signature[] = [];
  authorizersPeding = false;
  isObserver: boolean;
  userType = UserTypes;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private authUtilService: AuthUtilService,
    private layoutService: LayoutService,
    private envelopeService: EnvelopeService,
    private envelopeReminderService: EnvelopeReminderService,
    private fileEnvelopeService: FileEnvelopeService,
    private translate: TranslateService,
    private googleAnalitycsService: AnalyticsService,
    private modalService: NgbModal,
    private toastService: ToastService
  ) {
    this.languageBase = new LanguageBase(translate);
    if (!this.authService.signUserModel) {
      return;
    }

    this.canViewActionsButton =
      this.authService.getProfile() !== UserTypes.User;
    this.isObserver = this.authService.getProfile() !== UserTypes.User;
    this.isAdmin = this.authService.getProfile() === UserTypes.Admin;
    this.canSendWhatsApp = this.authService.signUserModel.sendWhatsapp;
    this.userId = this.authService.signUserModel.id;
  }

  ngAfterViewInit(): void {
    this.userCanViewEdit(this.isCollapsed);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['envelopeId'] && !changes['envelopeId'].firstChange) {
      if (changes['envelopeId'].currentValue == null) {
        return;
      }
      this.layoutService.toggleLoading(true);
      const includingIsDeleted =
        this.envelopeStatus === SentEnvelopeStatus.deleted ? true : false;
      this.envelopeService
        .getEnvelopeDetail(
          changes['envelopeId'].currentValue,
          true,
          true,
          true,
          includingIsDeleted
        )
        .subscribe(
          (data) => {
            this.envelope = Object.assign({}, data);
            this.envelope.signatories = Array.isArray(this.envelope.signatories) ? this.envelope.signatories : [];
            this.envelope.authorizers = Array.isArray(this.envelope.authorizers) ? this.envelope.authorizers : [];
            this.envelope.responsibles = Array.isArray((this.envelope as any).responsibles)
              ? (this.envelope as any).responsibles
              : [];
            this.authorizersPeding = this.envelope.authorizers.some(
              (el) => el.status === SignatureStatus.Awaiting
            );

            this.subscribeToUserChanges();

            this.processData();
            this.layoutService.toggleLoading(false);
            this.totalApprovedAuthorizations = this.envelope.authorizers.filter(
              (x) => x.status === 5
            ).length;

            const signatories = this.envelope.signatories;

            this.envelope.totalSignatures = signatories.length;
            this.totalSignatoriesRejectedReason = [];


            if(this.envelope.status === SentEnvelopeStatus.reproved){
              const authorized = this.envelope.authorizers;

                let reprovedDate = authorized.find(s => s.status === SignatureStatus.Approval_reproved)?.signatureDateTimeInfo || null;
                this.reprovedDate = reprovedDate;
            }

            signatories.forEach((x) => {
              if (
                x.envelopeRejectedHistory &&
                x.envelopeRejectedHistory.length > 0
              ) {
                const rejectReason = x.envelopeRejectedHistory[0].rejectReason;
                if (rejectReason) {
                  this.totalSignatoriesRejectedReason.push(rejectReason);
                }
              }
            });
          },
          (error) => this.layoutService.toggleLoading(false)
        );
    } else {
      this.updateEnvelope();
    }
  }

  private subscribeToUserChanges() {
    this.subscriptions.add(
      combineLatest([
        this.authUtilService.user,
        this.authUtilService.userSign,
      ]).subscribe(([user, userSign]) => {
        const userId = user?.id ?? null;
        const userType = userSign?.type;
        this.userTypeLogged = userType;

        if (userType === this.userType.PowerUser)
          this.isCreatedEnvelope = userId !== this.envelope.createdByUserId;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public getDescriptionReminderFrequency(): string {
    const items: any[] = [
      {
        id: 1,
        value: this.translate.instant(
          'envelope.signatory.reminderFrequency.doNotSend'
        ),
      },
      {
        id: 2,
        value: this.translate.instant(
          'envelope.signatory.reminderFrequency.EveryDay'
        ),
      },
      {
        id: 3,
        value: this.translate.instant(
          'envelope.signatory.reminderFrequency.EveryCountDay',
          { dayCount: 2 }
        ),
      },
      {
        id: 4,
        value: this.translate.instant(
          'envelope.signatory.reminderFrequency.EveryCountDay',
          { dayCount: 4 }
        ),
      },
      {
        id: 5,
        value: this.translate.instant(
          'envelope.signatory.reminderFrequency.EveryCountDay',
          { dayCount: 7 }
        ),
      },
    ];
    return items.find((el) => el.id === this.envelope.reminderFrequency).value;
  }

  processData() {
    this.tagStatus = {
      description: this.getStatusDescription(),
      tooltip: this.translate.instant('envelopeStatus'),
      tooltipPlacement: 'top',
      type: this.getStatusType(),
    };

    this.pill = {
      icon: {
        iconName: this.getIcon(),
        prefix: 'fas',
      },
      description: this.getStatusDescription(),
      type: this.getStatusType(),
    };
  }

  getIcon() {
    if (!this.envelope) {
      return null;
    }
    switch (this.envelope.status) {
      case SentEnvelopeStatus.pending:
        return 'clock';
      case SentEnvelopeStatus.completed:
        return 'check-circle';
      case SentEnvelopeStatus.expired:
        return 'clock';
      case SentEnvelopeStatus.reproved:
        return 'clock';
      case SentEnvelopeStatus.onApproval:
        return 'clock';
      case SentEnvelopeStatus.toFill:
        return 'clock';
      case SentEnvelopeStatus.deleted:
        return 'times-circle';
      case SentEnvelopeStatus.rejected:
        return 'times-circle';
      default:
        return null;
    }
  }

  getDateFormat() {
    return this.languageBase.getDateFortmatByLanguage(
      this.translate.currentLang
    );
  }

  getStatusType() {
    if (!this.envelope) {
      return null;
    }
    switch (this.envelope.status) {
      case SentEnvelopeStatus.pending:
        return Status.WARNING;
      case SentEnvelopeStatus.completed:
        return Status.SUCCESS;
      case SentEnvelopeStatus.expired:
        return Status.WARNING;
      case SentEnvelopeStatus.reproved:
        return Status.DANGER;
      case SentEnvelopeStatus.onApproval:
        return Status.INFO;
      case SentEnvelopeStatus.toFill:
        return Status.INFO;
      case SentEnvelopeStatus.deleted:
        return Status.DANGER;
      case SentEnvelopeStatus.rejected:
        return Status.DANGER;
      default:
        return null;
    }
  }

  getStatusDescription() {
    if (!this.envelope) {
      return '';
    }

    switch (this.envelope.status) {
      case SentEnvelopeStatus.pending:
        return this.translate.instant('envelope.sent.status.pending');
      case SentEnvelopeStatus.completed:
        return this.translate.instant('envelope.sent.status.completed');
      case SentEnvelopeStatus.expired:
        return this.translate.instant('envelope.sent.status.expired');
      case SentEnvelopeStatus.reproved:
        return this.translate.instant('envelope.sent.status.reproved');
      case SentEnvelopeStatus.onApproval:
        return this.translate.instant('envelope.sent.status.onApproval');
      case SentEnvelopeStatus.toFill:
        return this.translate.instant('envelope.sent.status.toFilled');
      case SentEnvelopeStatus.deleted:
        return this.translate.instant('envelope.sent.status.deleted');
      case SentEnvelopeStatus.rejected:
        return this.translate.instant('envelope.sent.status.rejected');
    }
  }

  isCompleted(): boolean {
    return this.envelope.status === SentEnvelopeStatus.completed;
  }

  isDiscardDisabled(): boolean {
    if (
      this.isCreatedEnvelope &&
      this.userTypeLogged === this.userType.PowerUser
    ) {
      return true;
    }
    return this.isCompleted();
  }

  disablePrinting() {
    return !this.isCompleted();
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  downloadOriginalFile() {
    this.trackAnalyticsEvent('Signer_Enviado_Detalhe_Original');
    this.layoutService.toggleLoading(true);
    this.fileEnvelopeService
      .downloadPDF(this.envelope.id)
      .then(() => {
        this.layoutService.toggleLoading(false);
      })
      .catch((x) => this.layoutService.toggleLoading(false));
  }

  downloadSignedFile() {
    this.trackAnalyticsEvent('Signer_Enviado_Detalhe_Assinado');
    this.layoutService.toggleLoading(true);
    this.fileEnvelopeService
      .downloadSignedPDF(this.envelope.id)
      .then(() => {
        this.layoutService.toggleLoading(false);
      })
      .catch((x) => this.layoutService.toggleLoading(false));
  }

  downloadPrintingFile(withStamp) {
    this.trackAnalyticsEvent(
      withStamp
        ? 'Signer_Enviado_Detalhe_Imp_ComCarimbo'
        : 'Signer_Enviado_Detalhe_Imp_SemCarimbo'
    );
    this.layoutService.toggleLoading(true);
    this.fileEnvelopeService
      .downloadPrintingPDF(this.envelope.id, withStamp)
      .then(() => {
        this.layoutService.toggleLoading(false);
      })
      .catch((x) => this.layoutService.toggleLoading(false));
  }

  toAssigned(accessKey) {
    const pathLocal = `${location.protocol}//${location.host}/#/${RoutePages.Signature}?accessKey=${accessKey}`;
    const pathProd = `${location.protocol}//${location.host}${location.pathname}#/${RoutePages.Signature}?accessKey=${accessKey}`;
    window.open(environment.production ? pathProd : pathLocal);
  }

  resendMail(signatory) {
    this.trackAnalyticsEvent('Signer_Enviado_Detalhe_Enviar', 'E-mail');
    this.layoutService.toggleLoading(true);
    this.envelopeReminderService
      .resendMail(signatory.envelopeSignatoryId)
      .subscribe(
        (x) => {
          this.toastService.createNewToast({
            text: this.translate.instant('resendMailMessage', {
              email: signatory.mail,
            }),
            autoHide: true,
            type: 'success',
          });
          this.layoutService.toggleLoading(false);
        },
        (error: any) => {
          this.layoutService.toggleLoading(false);
        }
      );
  }

  resendWhatsApp(signatory) {
    this.trackAnalyticsEvent('Signer_Enviado_Detalhe_Enviar', 'Whats');
    this.layoutService.toggleLoading(true);
    this.envelopeReminderService
      .resendWhatsApp(signatory.envelopeSignatoryId)
      .subscribe(
        (x) => {
          this.toastService.createNewToast({
            text: this.translate.instant('resendWhatsAppMessage', {
              telephone: StringUtil.obfuscateTelephone(signatory.phoneNumber),
            }),
            autoHide: true,
            type: 'success',
          });
          this.layoutService.toggleLoading(false);
        },
        (error: any) => {
          this.layoutService.toggleLoading(false);
        }
      );
  }

  showLinkToSign(envelopeSignatory) {
    const pathLocal = `${location.protocol}//${location.host}/#/${RoutePages.Signature}?accessKey=${envelopeSignatory.accessKey}`;
    const pathProd = `${location.protocol}//${location.host}${location.pathname}#/${RoutePages.Signature}?accessKey=${envelopeSignatory.accessKey}`;
    const link = environment.production ? pathProd : pathLocal;

    this.toastService.createNewToast({
      text: `<span class="copy-link-toast">${envelopeSignatory.name}:</span>`,
      autoHide: true,
      type: 'info',
      delay: 10000,
      button: {
        label: 'copyLink',
        action: () => this.copyLink(link),
      },
    });
  }

  private copyLink(link: string) {
    navigator.clipboard.writeText(link).then(() => {
      this.toastService.createNewToast({
        text: this.translate.instant('linkCopied'),
        autoHide: true,
        type: 'success',
      });
    });
  }

  showModalEnvelopeEditOrDeleteOrArchived(modalContent, analyticsAction?: string) {
    if (analyticsAction) {
      this.trackAnalyticsEvent(analyticsAction);
    }

    this.elementSelected = this.envelope;
    this.activeModal = this.modalService.open(modalContent, {
      size: 'md',
      scrollable: false,
    });
  }

  updateEnvelope() {
    this.layoutService.toggleLoading(true);
    if (this.envelopeId != null) {
      this.envelopeService.getEnvelopeDetail(this.envelopeId).subscribe(
        (data) => {
          this.envelope = Object.assign({}, data);
          this.envelope.signatories = Array.isArray(this.envelope.signatories) ? this.envelope.signatories : [];
          this.envelope.authorizers = Array.isArray(this.envelope.authorizers) ? this.envelope.authorizers : [];
          this.envelope.responsibles = Array.isArray((this.envelope as any).responsibles)
            ? (this.envelope as any).responsibles
            : [];
          this.authorizersPeding = this.envelope.authorizers.some(
            (el) => el.status === SignatureStatus.Awaiting
          );
          this.processData();
          this.layoutService.toggleLoading(false);
          this.totalApprovedAuthorizations = this.envelope.authorizers.filter(
            (x) => x.status === 5
          ).length;
          this.envelope.totalSignatures = this.envelope.signatories.length;
          this.updateCardEnvelope.emit(this.envelope);
        },
        (error) => this.layoutService.toggleLoading(false)
      );
    } else this.layoutService.toggleLoading(false);
  }

  deleteEnvelope() {
    this.layoutService.toggleLoading(true);
    this.envelopeService
      .getEnvelopeDetail(this.envelopeId, true, true, true, true)
      .subscribe(
        (data) => {
          this.envelope = Object.assign({}, data);
          this.envelope.signatories = Array.isArray(this.envelope.signatories) ? this.envelope.signatories : [];
          this.envelope.authorizers = Array.isArray(this.envelope.authorizers) ? this.envelope.authorizers : [];
          this.envelope.responsibles = Array.isArray((this.envelope as any).responsibles)
            ? (this.envelope as any).responsibles
            : [];
          this.authorizersPeding = this.envelope.authorizers.some(
            (el) => el.status === SignatureStatus.Awaiting
          );
          this.processData();
          this.layoutService.toggleLoading(false);
          this.totalApprovedAuthorizations = this.envelope.authorizers.filter(
            (x) => x.status === 5
          ).length;
          this.envelope.totalSignatures = this.envelope.signatories.length;
          this.updateCardEnvelope.emit(this.envelope);
        },
        (error) => this.layoutService.toggleLoading(false)
      );
  }

  onDiscardEnvelopeDeleted() {
    this.trackAnalyticsEvent('Signer_Enviado_Detalhe_Descatar_Excluir');
    this.deleteEnvelope();
  }

  onEnvelopeArchived() {
    this.deleteEnvelope();
  }

  collapseClosed(event) {
    this.userCanViewEdit(event);
  }

  userCanViewEdit(isCollapsed) {
    this.canShowEditButton = !isCollapsed && this.isObserver ? true : false;
  }

  getDescriptionSignatureType(signatureTypeSelected: SignatureType) {
    switch (signatureTypeSelected) {
      case SignatureType.ELETRONIC:
        return 'envelope.signatory.signatureType.electronics';
      case SignatureType.DIGITAL:
        return 'envelope.signatory.signatureType.digital';
      case SignatureType.SELFIE:
        return 'envelope.signatory.signatureType.selfie';
      default:
        EMPTY;
    }
  }

  getNotificationMessage(signature: Signature) {
    if (
      signature.lastNotificationSentDateDateTimeInfo &&
      signature.lastNotificationSentDateDateTimeInfo.datetimeUtcShortDescription
    ) {
      return this.translate
        .instant('lastNotificationResendMail')
        .toString()
        .replace(
          '{0}',
          signature.lastNotificationSentDateDateTimeInfo
            .datetimeUtcShortDescription
        );
    }

    return this.translate.instant('resendMail');
  }

  getToolTipSignatoryMessage(signature: Signature) {
    if (
      signature.lastAccessSignaturePageDate &&
      signature.lastAccessSignaturePageDate.datetimeUtcShortDescription &&
      signature.status !== SignatureStatus.Signed
    ) {
      return this.translate
        .instant('envelope.sent.signatory.lastAccessSignaturePageDate')
        .toString()
        .replace(
          '{0}',
          signature.lastAccessSignaturePageDate.datetimeUtcShortDescription
        );
    } else if (signature.status === SignatureStatus.Signed) {
      return this.translate.instant('envelope.sent.signed').toString();
    }

    return this.translate.instant(
      'envelope.sent.signatory.dontAccessSignaturePageDate'
    );
  }

  getToolTipAuthorizeMessage(signature: Signature) {
    if (
      signature.lastAccessSignaturePageDate &&
      signature.lastAccessSignaturePageDate.datetimeUtcShortDescription &&
      signature.status !== SignatureStatus.Approval_approved &&
      signature.status !== SignatureStatus.Approval_reproved
    ) {
      return this.translate
        .instant('envelope.sent.authorizer.lastAccessSignaturePageDate')
        .toString()
        .replace(
          '{0}',
          signature.lastAccessSignaturePageDate.datetimeUtcShortDescription
        );
    } else if (signature.status === SignatureStatus.Approval_approved) {
      return this.translate.instant('envelope.sent.authorized').toString();
    } else if (signature.status === SignatureStatus.Approval_reproved) {
      return this.translate.instant('envelope.sent.reproved').toString();
    }
    return this.translate.instant(
      'envelope.sent.authorizer.dontAccessSignaturePageDate'
    );
  }

  getToolTipResponsibleMessage(signature: Signature) {
    if (
      signature.lastAccessSignaturePageDate &&
      signature.lastAccessSignaturePageDate.datetimeUtcShortDescription &&
      signature.status !== SignatureStatus.Filled
    ) {
      return this.translate
        .instant('envelope.sent.responsible.lastAccessSignaturePageDate')
        .toString()
        .replace(
          '{0}',
          signature.lastAccessSignaturePageDate.datetimeUtcShortDescription
        );
    } else if (signature.status === SignatureStatus.Filled) {
      return this.translate.instant('envelope.sent.filled').toString();
    }
    return this.translate.instant(
      'envelope.sent.responsible.dontAccessSignaturePageDate'
    );
  }

  getTranslatedReasons(rejectReason: string, rejectReasonOthers: string): string {
    const reasonIds = rejectReason.split(',');

    let translatedReasons = reasonIds
      .map(reasonId => reasonId.trim())
      .filter(reasonId => {
        return !(reasonId === '5' && rejectReasonOthers);
      })
      .map(reasonId => {
        const reasonKey = this.getReasonKeyByEnumId(reasonId);
        return this.translate.instant(reasonKey);
      })
      .join(', ');

    translatedReasons += rejectReasonOthers
    ? (translatedReasons ? `, ${rejectReasonOthers}` : rejectReasonOthers)
    : '';

    return translatedReasons;
  }

  getReasonKeyByEnumId(enumId: string): string {
    const reasonMapping = {
      '1': 'modalReasonRejected.reasonsCheckBoxes.one',
      '2': 'modalReasonRejected.reasonsCheckBoxes.two',
      '3': 'modalReasonRejected.reasonsCheckBoxes.three',
      '4': 'modalReasonRejected.reasonsCheckBoxes.four',
      '5': 'modalReasonRejected.reasonsCheckBoxes.five'
    };

    return reasonMapping[enumId];
  }

  private trackAnalyticsEvent(action: string, label?: string): void {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(AnalyticEventClient.TK_PT_SIGNER_SENT, action, label)
    );
  }


}
